import React, { useMemo } from "react";
import { Partner } from "../../../../api/staff";
import { useTranslations } from "../../../../contexts/translation.context";
import { getPartnerStatusConfig } from "../constants";

interface PartnerStatusCellProps {
  partner: Partner;
}

/**
 * PartnerStatusCell Component
 *
 * Renders the partner status chip with appropriate color
 *
 * Based on Figma design
 */
const PartnerStatusCell: React.FC<PartnerStatusCellProps> = ({ partner }) => {
  const { t } = useTranslations();

  const statusConfig = useMemo(() => {
    return getPartnerStatusConfig(partner.status, t);
  }, [partner.status, t]);

  return (
    <span
      className="inline-flex h-[24px] items-center justify-center rounded-lg px-[8px] text-[12px] font-medium whitespace-nowrap"
      style={{
        backgroundColor: `${statusConfig.color}20`,
        color: statusConfig.color
      }}
    >
      {statusConfig.label}
    </span>
  );
};

export default PartnerStatusCell;
